import { Component, Input } from '@angular/core';

@Component({
  selector: 'rappider-data-schema-list',
  templateUrl: './data-schema-list.component.html',
  styleUrls: ['./data-schema-list.component.scss']
})
export class RappiderDataSchemaListComponent {

  @Input() nodes = [];
}
